<nav id="sidebar2" >
    <div class="title" >
        <h4>Gestiones</h4>
    </div>
    <ul class="list-unstyled components mb-5" *ngxPermissionsOnly="['evaluacionWeb']">
      <li [routerLinkActive]="['active']" #rla="routerLinkActive" >
        <a [routerLink]="'/gestiones'"><img src="../../../assets/images/general/folder.png" >&nbsp;&nbsp;&nbsp;&nbsp;Acierto</a>
      </li>
      <div id="sidebar3" *ngIf="rla.isActive">
        <li [routerLinkActive]="
        ['active', selectSegemento(item.id)]"
        [routerLinkActiveOptions]="{exact:true}"
        *ngFor="let item of lstCategories" >
          <a [routerLink]="['/gestiones', item.id]" style="margin-top: 5px !important;" *ngIf="item.access">
            <span class="iconsidebar3 icon-oval" style="width: 8px;height: 8px;"></span>
            <span class="ml-3">{{ item.name }}</span>
          </a>
        </li>
      </div>
      <!-- <li [routerLinkActive]="['active', selectSegemento()]" [routerLinkActiveOptions]="{exact:true}">
        <a [routerLink]="['/gestiones', 4]"><img src="../../../assets/images/general/folder.png" >&nbsp;&nbsp;&nbsp;&nbsp;Autogestión</a>
      </li> -->

    </ul>
</nav>
